import { render } from "./WaitlistFooter.vue?vue&type=template&id=2641badc&scoped=true"
import script from "./WaitlistFooter.vue?vue&type=script&lang=js"
export * from "./WaitlistFooter.vue?vue&type=script&lang=js"

import "./WaitlistFooter.vue?vue&type=style&index=0&id=2641badc&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2641badc"]])

export default __exports__